import { lazy } from "react";
import { useBooking } from "@/app/Bookings/Hooks/useBooking";

const TakePaymentDialog = lazy(
  () => import("@/app/Bookings/Components/Dialogs/TakePaymentDialog"),
);

/**
 * Loads the full booking record the payment dialog needs, so the call list only
 * pays for it when a rep actually takes payment.
 */
export function CallbackLeadTakePaymentDialog({
  bookingId,
}: {
  bookingId: string;
}) {
  const booking = useBooking(bookingId);

  return <TakePaymentDialog booking={booking} />;
}
